import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import isInt from "lodash/isInteger";
import request from "~/utils/request";

export const useAxios = (url, deleteID, id) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await request.get(url);
        setLoading(false);

        setData(response.data.data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    const deletedItem = isInt(deleteID)
      ? data.filter((item) => item.id !== deleteID)
      : deleteID;
    setData(deletedItem);
  }, [deleteID]);

  return { data, error, loading };
};

useAxios.propTypes = {
  url: PropTypes.string,
  deleteID: PropTypes.number,
  error: PropTypes.any,
  loading: PropTypes.bool,
  data: PropTypes.any,
};
